import { FC } from 'react'
import { BidDetailBlockDefault, BidDetailBlockProps } from './BidDetailBlockDefault'

export const BidDetailBlock: FC<BidDetailBlockProps> = ({ bidType, ...restProps }) => {
  return <BidDetailBlockDefault bidType={bidType} {...restProps} />
}
